<script>
import lazyLoadComponent from '@router/lazyload-component'

import BaseButtonDialog from '@components/BaseButtonDialog'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
import { notification } from '@utils/notification'
import { saveState, getSavedState } from '@utils/browser-help'

const initData = () => {
  return {
    level: 0,
    state: 1,
    evaluationPolicy: 'ONCE', //NONE|ONCE|ALWAYS
  }
}

export default {
  page: {
    title: '分類設定',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    BaseButtonDialog,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    ItemDetail: () => lazyLoadComponent(import('./ServiceItemDetail')),
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      categoryList: [...this.serviceCategory],
      tableData: [
        {
          id: 1,
          title: '狗狗',
          children: [
            {
              id: 11,
              title: '大型犬',
            },
            {
              id: 12,
              title: '中型犬',
            },
            {
              id: 13,
              title: '小型犬',
            },
          ],
        },
        {
          id: 2,
          title: '貓咪',
          children: [
            {
              id: 21,
              title: '短毛',
            },
            {
              id: 22,
              title: '長毛',
            },
          ],
        },
      ],
      selectedCoupons: [],
      selectedDetail: {},
      filterData: {
        state: '',
        productId: '',
        type: '',
        body: '',
      },
      productTypeList: Object.freeze(productTypeList),
      visibleDetail: false,
      previousPage: 1,
      previousTotal: 0,
      tryingFetchDetail: false,
      visibleDialog: false,
      visibleDialogForAdd: false,
      submitData: Object.assign(initData(), this.defaultValue),
      submitDataCreate: Object.assign(initData(), this.defaultValue),
      editData: {},
      isNoSize: false,
      isDeleteMode: false,
      saveLoading: false,
      isInitializing: false,
    }
  },
  computed: {
    submitRules() {
      return {
        title: [
          {
            required: true,
            message: '請填寫分類名',
          },
        ],
        // parentId: [
        //   {
        //     required: true,
        //     message: '請填寫姓名',
        //   },
        // ],
      }
    },
  },
  watch: {
    'submitDataCreate.parentId': function() {
      this.handleEvaluationPolicy(this.submitDataCreate)
    },
    'submitDataCreate.state': function() {
      this.handleEvaluationPolicy(this.submitDataCreate)
    },
    'submitData.parentId': function(newVal) {
      if (this.isInitializing) return // 如果正在初始化，就不執行自動邏輯
      if (newVal) {
        this.handleEvaluationPolicy(this.submitData)
      }
    },
    'submitData.state': function() {
      if (this.isInitializing) return // 如果正在初始化，就不執行自動邏輯
      this.handleEvaluationPolicy(this.submitData)
    },
  },
  created() {
    this.tryToFetchList()
  },
  mounted() {
    this.getIsDeleteMode()
  },
  methods: {
    async getIsDeleteMode() {
      this.isDeleteMode = await getSavedState('isDeleteMode')
    },
    async tryToFetchList() {
      this.categoryList = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0, state: [0, 1] })
      this.isNoSize = this.categoryList.some((item) => {
        return item.children.length === 0
      })
    },
    async tryToStoreCategory() {},
    async tryToRemove(id) {
      try {
        await messageBoxDelete('分類')
        try {
          await this.$store.dispatch('product/removeServiceCategory', { ids: [id] })
          messageDelete()
          this.tryToFetchList()
        } finally {
        }
      } catch {}
    },
    tryToEdit(data) {
      this.isInitializing = true // 開啟鎖定
      this.submitData = structuredClone(data)
      this.submitData.params = ''

      // 使用 $nextTick 等 Vue 處理完 watch 後再解鎖
      this.$nextTick(() => {
        this.isInitializing = false
      })
      this.visibleDialog = true
    },
    async tryToSave(isNew) {
      try {
        this.saveLoading = true
        const submit = isNew ? { ...this.submitDataCreate } : { ...this.submitData }
        if (isNew) {
          const payload = { title: submit.title, state: submit.state, evaluationPolicy: submit.evaluationPolicy, parentId: submit.parentId }
          await this.$refs.newForm.validate()
          await this.$store.dispatch('product/postServiceCategory', payload)
        } else {
          const payload = {
            title: submit.title,
            parentId: submit.parentId,
            alias: submit.alias,
            state: submit.state,
            type: submit.type,
            evaluationPolicy: submit.evaluationPolicy, // "NONE", "ONCE", "ALWAYS"
            params: submit.params,
          }

          await this.$refs.editForm.validate()
          await this.$store.dispatch('product/patchServiceCategory', { categoryId: submit.id, payload })
        }
        // 舊的的新增服務先command掉
        // await this.$store.dispatch('product/storeServiceCategory', submit)
        if (isNew) {
          messageStore('add')
        } else {
          messageStore('edit')
        }
        if (isNew && !this.isNoSize) {
          notification('分類資訊', '一般服務', 'prices')
        }

        await this.tryToFetchList()
        this.visibleDialog = false
        this.visibleDialogForAdd = false
        this.$emit('update-category')
        this.submitDataCreate = Object.assign({}, initData())
      } catch (err) {
        console.error(err)
        this.$message.error('儲存失敗，請稍後再嘗試一次')
      } finally {
        this.saveLoading = false
      }
    },
    changeParentCreate() {
      this.submitDataCreate.level = this.submitDataCreate.parentId ? 1 : 0
    },
    changeParent() {
      this.submitData.level = this.submitData.parentId ? 1 : 0
    },
    openAdd() {
      this.visibleDialogForAdd = true
    },
    handleEvaluationSwitchChange(val, targetObj) {
      if (val) {
        targetObj.evaluationPolicy = 'ONCE'
      } else {
        targetObj.evaluationPolicy = 'NONE'
      }
    },
    handleEvaluationPolicy(dataObj) {
      if (dataObj.parentId || dataObj.state === 0) {
        dataObj.evaluationPolicy = 'NONE'
      }
    },
    fetchDeleteServiceCategory(id, title) {
      this.$confirm(`是否確認刪除${title}?`, {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await this.$store.dispatch('product/deleteServiceCategory', { categoryId: id })
          await this.tryToFetchList()
          this.$message.success('已成功刪除')
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('刪除失敗，請重新嘗試')
        })
    },
    fetch,
  },
}
</script>

<template>
  <div :class="$style.page">
    <div :class="$style.upperDiv">
      <el-button class="is-round upperBtn" type="primary" @click="openAdd">
        <BaseIcon name="plus" />
        <span>新增自訂分類</span>
      </el-button>
    </div>
    <el-alert v-if="isNoSize" style="margin-bottom:20px" title="請新增子分類，若沒有子分類，將無法建立服務方案" type="warning"> </el-alert>
    <el-row :gutter="40">
      <el-col v-if="false" :md="10" :span="24">
        <el-form ref="newForm" :model="submitDataCreate" :rules="submitRules" label-position="top" class="el-form--floating mb-5 mb-md-0">
          <el-form-item label="名稱" prop="title">
            <el-input v-model="submitDataCreate.title" placeholder="請輸入分類名稱"></el-input>
          </el-form-item>
          <el-form-item label="指派上層分類" prop="parentId">
            <el-select v-model="submitDataCreate.parentId" placeholder="指派上層分類" @change="changeParentCreate">
              <el-option value label="無上層分類"></el-option>
              <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :md="24" :span="24">
        <div class="el-table-wrapper isCategory">
          <el-table :data="categoryList" default-expand-all :class="$style['table']" class="tree-table" row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
            <el-table-column prop="categoryTitle" label="名稱" min-width="280"> </el-table-column>
            <el-table-column v-slot="{ row }" prop="children.length" min-width="110" label="項目數量" align="center">{{ row.children.length > 1 ? row.children.length : 1 }} </el-table-column>
            <el-table-column v-slot="{ row }" label="狀態" min-width="140" align="center">
              <span :style="{ color: !!row.state ? '#12C494' : '#909399' }">{{ !!row.state ? '啟用' : '禁用' }}</span>
            </el-table-column>
            <el-table-column v-slot="{ row }" label="評估" min-width="140" align="center">
              <span :style="{ color: row.evaluationPolicy === 'NONE' ? '#909399' : '#12C494' }">{{
                row.evaluationPolicy === 'NONE' ? '關閉' : row.evaluationPolicy === 'ONCE' ? '評估（首次)' : '評估（每次)'
              }}</span>
            </el-table-column>
            <el-table-column v-slot="{ row }" label="編輯" min-width="180" align="right" style="display:flex;gap:8px;justify-content: flex-end; ">
              <el-tooltip content="編輯" placement="top">
                <el-button plain @click="tryToEdit(row)">
                  <BaseIcon name="edit" style="font-size:20px;" class="text-primary" />
                </el-button>
              </el-tooltip>
              <el-tooltip content="刪除" placement="top">
                <el-button plain @click.stop="fetchDeleteServiceCategory(row.id, row.title)">
                  <BaseIcon name="trash-alt" style="font-size:20px;" />
                </el-button>
              </el-tooltip>
              <el-tooltip v-if="isDeleteMode" content="刪除" placement="top">
                <el-button class="is-no-style" type="danger" plain size="mini" @click.stop="tryToRemove(row.id)">
                  <BaseIcon name="trash-alt" style="font-size:20px;" />
                </el-button>
              </el-tooltip>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="'編輯美容服務分類'" :visible.sync="visibleDialog" top="0" width="550px" append-to-body>
      <el-form ref="editForm" :model="submitData" label-position="top" class="el-form--floating">
        <el-form-item label="名稱" prop="title" required>
          <el-input v-model="submitData.title" placeholder="請輸入分類名稱"></el-input>
        </el-form-item>
        <el-form-item label="是否啟用" prop="state">
          <el-switch v-model="submitData.state" active-text="啟用" inactive-text="禁用" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <!-- <el-form-item v-if="submitData.level !== 0" label="指派上層分類" prop="parentId">
          <el-select v-model="submitData.parentId" placeholder="指派上層分類" @change="changeParent">
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item v-if="!submitData.parentId && submitData.state" label="是否評估" prop="evaluationPolicy">
          <el-switch :value="submitData.evaluationPolicy !== 'NONE'" @change="(val) => handleEvaluationSwitchChange(val, submitData)" active-text="啟用" inactive-text="關閉"> </el-switch>

          <el-radio-group v-if="submitData.evaluationPolicy !== 'NONE'" v-model="submitData.evaluationPolicy" style="margin-left:24px">
            <el-radio label="ONCE">首次服務時評估</el-radio>
            <el-radio label="ALWAYS">每次評估</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-else-if="submitData.parentId || submitData.state" label="是否評估(同上層分類)">
          <div :style="{ color: submitData.evaluationPolicy === 'NONE' ? '#909399' : '#EA6A2A' }"
            >{{ submitData.evaluationPolicy === 'NONE' ? '關閉（不評估）' : submitData.evaluationPolicy === 'ONCE' ? '評估(首次服務評估)' : ' 評估(每次評估)' }}
          </div>
        </el-form-item>
      </el-form>
      <div :class="$style.bottomBtn">
        <el-button class="is-round" style="width:50%" @click="visibleDialog = false">取消</el-button>
        <el-button class="is-round" style="width:50%" type="primary" @click="tryToSave(false)">儲存變更</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'新增美容服務分類'" :visible.sync="visibleDialogForAdd" top="0" width="550px" append-to-body>
      <el-form ref="newForm" :model="submitDataCreate" :rules="submitRules" label-position="top" class="el-form--floating mb-5 mb-md-0">
        <el-form-item label="名稱" prop="title">
          <el-input v-model="submitDataCreate.title" placeholder="請輸入分類名稱"></el-input>
        </el-form-item>
        <el-form-item label="指派上層分類" prop="parentId">
          <el-select v-model="submitDataCreate.parentId" placeholder="指派上層分類" @change="changeParentCreate">
            <el-option value label="無上層分類"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否啟用" prop="state">
          <el-switch v-model="submitDataCreate.state" active-text="啟用" inactive-text="禁用" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>

        <el-form-item v-if="!submitDataCreate.parentId && submitDataCreate.state" label="是否評估" prop="evaluationPolicy">
          <el-switch :value="submitDataCreate.evaluationPolicy !== 'NONE'" @change="(val) => handleEvaluationSwitchChange(val, submitDataCreate)" active-text="啟用" inactive-text="關閉"> </el-switch>

          <el-radio-group v-if="submitDataCreate.evaluationPolicy !== 'NONE'" v-model="submitDataCreate.evaluationPolicy" style="margin-left:24px">
            <el-radio label="ONCE">首次服務時評估</el-radio>
            <el-radio label="ALWAYS">每次評估</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div :class="$style.bottomBtn">
        <el-button class="is-round" style="width:50%" @click="visibleDialogForAdd = false">取消</el-button>
        <el-button class="is-round" style="width:50%" type="primary" @click="tryToSave(true)">儲存變更</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>

.table {
  @include layer-elevation(5);
  width: 100%;

  :global {
    thead tr > th {
      background-color: $color-line-dark !important;
      padding-right: 10px;
      padding-left: 10px;
    }

    tbody tr > td {
      padding-right: 10px;
      padding-left: 10px;
    }

    .el-table__row--level-1 > td {
      &:first-child {
        border-left: 3px solid $color-primary;
      }
    }
  }
}

.page {
  position: relative;
  margin-bottom: 50px;
}

.upperDiv {
  background-color: $color-body-bg;
  padding-bottom: 20px;
  padding-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;

  :global {
    .upperBtn {
      width: 180px;
      position: relative;
      right: 10px;
    }
  }
}

.bottomBtn {
  display: flex;
}
</style>
